import { getStaffScopedApiPrefix } from '@brands/Utils/staffScopedApiPrefix';

import { client } from '../client';
import { CasePayload } from './createNewCase';
import { ICase } from './types/ICase';

export const editCaseById = async (case_id: number, payload: CasePayload, userRole?: string): Promise<ICase> => {
  const prefix = getStaffScopedApiPrefix(userRole);
  const path = prefix ? `${prefix}/cases/${case_id}` : `/cases/${case_id}`;
  const { data } = await client.patch(path, payload);

  return data;
};
